import { useState } from 'react'
import { InputGroup, InputRightElement, Spinner, Stack } from '@chakra-ui/react'

import { CustomFormValidateField } from 'components/tools/CustomForm/types'
import { FormItem, MaskedInput } from 'components'
import { cpfMask } from 'utils/masks'
import { validateCPF } from 'utils/validation/validators'
import CustomFormFieldErrorMessage from 'components/tools/CustomForm/commonComponents/CustomFormFieldErrorMessage'
import useGetPersonByCPF from 'components/tools/CustomForm/hooks/useGetPersonByCPF'
import CustomFormPersonByCPF from 'components/tools/CustomForm/commonComponents/CustomFormPersonByCPF'
import useUnregisterDefaultValueField from '../../hooks/useUnregisterDefaultValueField'
import { DefaultValueCommonProps } from '../../types/DefaultValueCommonProps'
import useSetDefaultValueOnNotArrayData from '../../hooks/useSetDefaultValueOnNotArrayData'

export default function DefaultValueCPF({ formMethods, question }: DefaultValueCommonProps) {
  const [isFieldValid, setIsFieldValid] = useState<CustomFormValidateField>({
    isValid: true,
    message: '',
  })

  const { getPersonByCPF, loadingCPF, person } = useGetPersonByCPF()

  const handleValidateCPF = async (cpf: string): Promise<boolean> => {
    let initialValue = { isValid: true, message: '' }

    if (cpf) {
      const apiErrorMessage = await getPersonByCPF(cpf)

      if (apiErrorMessage !== '') {
        initialValue = { isValid: false, message: 'CPF inválido' }
      }

      if (!validateCPF(cpf)) {
        initialValue = { isValid: false, message: 'CPF está incorreto' }
      }
    }

    setIsFieldValid(initialValue)
    return initialValue.isValid
  }

  useUnregisterDefaultValueField({ formMethods })

  useSetDefaultValueOnNotArrayData({ formMethods, question })

  return (
    <Stack spacing={0}>
      <FormItem label="Valor inicial">
        <InputGroup>
          <MaskedInput
            mask={cpfMask}
            {...formMethods.register('default_value', {
              validate: handleValidateCPF,
              onBlur: async (event) => {
                const cpf = event.target.value
                await handleValidateCPF(cpf)
              },
            })}
          />

          <InputRightElement>{loadingCPF && <Spinner />}</InputRightElement>
        </InputGroup>
      </FormItem>

      <CustomFormFieldErrorMessage {...isFieldValid} />

      <CustomFormPersonByCPF person={person} />
    </Stack>
  )
}
